export default __webpack_public_path__ + "static/form-default-values-dont-b4961c2b644f54753921112f5c93085d.png";